import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter } from "react-router-dom";

import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';


const loc = window.location || {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

        <BrowserRouter basename={loc.pathname || '/'}>
            <App />
        </BrowserRouter>
        
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
